import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    mails: {
        current_page: 1,
        data: [],
        last_page: 1,
        per_page: 10,
        total: 1
    },
    user_contacts: [],
    priorities: [],
    active_signature: [],
    active: [],
    schedule_mails: [],
    unseenMailCount : 0,
    currentMail: {},
    imapConfig: {
        email: '',
        fullname: ''
    }
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
